import { StyleSheet } from 'aphrodite';
export const styles = StyleSheet.create({
    
    content: {
        display: "grid",
        gridTemplateRows: "min-content 1fr",
        flex: 1,
        marginLeft: 40,
        marginRight: 40,
        height: "100%"
    },

    title: {
        fontSize: 25,
        color: "#666666ff",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10,
        marginBottom: 10,

    },
    
    chart_container: {
        display: "grid",
        gridTemplateColumns: "1fr auto 1fr",
        flexGrow: 1,
        marginLeft: 10,
        marginRight: 10,
    },

    chart : {
        margin: "auto",
    },

    hover: {
        ":hover": {
            cursor: "pointer",
        }
    },

    legendContainer: {
        display: 'grid',
        gridTemplateColumns: "min-content",
        alignContent: 'center'
    },

    legendCard: {
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10,
        marginBottom: 10,
    },

    legends: {
        overflowY: "auto",
        maxHeight: "450px",
        paddingLeft: "0.8em",
    },

    legendItem : {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginTop: 10,
        paddingLeft: 10,
        paddingRight: 20,
        ":hover": {
            cursor :"pointer",
            color: "black",
            fontWeight: "bold",
            textDecoration: "underline",
        }
    },

    legendLabel : {
        fontSize:16,
        color:"gray"
    },

    total : {
        marginTop: 40,
        marginLeft: "auto",
        marginRight: "auto",
        fontSize: 20,
        textAlign: "center"
    }

})



// WEBPACK FOOTER //
// ./src/styles/CollegePage.ts